import React, { Component } from "react";
import { Link } from "react-router-dom";
import Notifications from "./header/Notifications";
import GlobalSearch from "./header/GlobalSearch";

export default class Header extends Component {
  render() {
    const userStr = localStorage.getItem("user");
    const user = userStr ? JSON.parse(userStr) : {};
    const name = user.name || user.username || "User";
    const initial = name.charAt(0).toUpperCase();

    return (
      <div
        id="kt_header"
        className="kt-header kt-grid__item  kt-header--fixed "
      >
        {/* begin:: Header Menu */}
        <button
          className="kt-header-menu-wrapper-close"
          id="kt_header_menu_mobile_close_btn"
        >
          <i className="la la-close" />
        </button>
        <div
          className="kt-header-menu-wrapper"
          id="kt_header_menu_wrapper"
        ></div>
        {/* end:: Header Menu */}
        {/* begin:: Header Topbar */}
        <div className="kt-header__topbar">
          {/*begin: Global Search */}
          <div className="kt-header__topbar-item kt-header__topbar-item--search">
            <GlobalSearch />
          </div>
          {/*end: Global Search */}
          {/*begin: Notifications */}
          <Notifications />
          {/*end: Notifications */}

          {/*begin: User Bar */}
          <div className="kt-header__topbar-item kt-header__topbar-item--user">
            <div
              className="kt-header__topbar-wrapper"
              data-toggle="dropdown"
              data-offset="0px,0px"
            >
              <div className="kt-header__topbar-user">
                <span className="kt-header__topbar-welcome kt-hidden-mobile">
                  Hi,
                </span>
                <span className="kt-header__topbar-username kt-hidden-mobile">
                  {name}
                </span>
                <img
                  className="kt-hidden"
                  alt="Pic"
                  src="./assets/media/users/300_25.jpg"
                />
                {/*use below badge element instead the user avatar to display username's first letter(remove kt-hidden class to display it) */}
                <span className="kt-badge kt-badge--username kt-badge--unified-success kt-badge--lg kt-badge--rounded kt-badge--bold">
                  {initial}
                </span>
              </div>
            </div>
            <div className="dropdown-menu dropdown-menu-fit dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
              {/*begin: Head */}
              <div
                className="kt-user-card kt-user-card--skin-dark kt-notification-item-padding-x"
                style={{ backgroundImage: "url(./assets/media/misc/bg-1.jpg)" }}
              >
                <div className="kt-user-card__avatar">
                  <img
                    className="kt-hidden"
                    alt="Pic"
                    src="./assets/media/users/300_25.jpg"
                  />
                  {/*use below badge element instead the user avatar to display username's first letter(remove kt-hidden class to display it) */}
                  <span className="kt-badge kt-badge--lg kt-badge--rounded kt-badge--bold kt-font-success">
                    {initial}
                  </span>
                </div>
                <div className="kt-user-card__name">{name}</div>
              </div>
              {/*end: Head */}
              {/*begin: Navigation */}
              <div className="kt-notification">
                <Link to="/profile" className="kt-notification__item">
                  <div className="kt-notification__item-icon">
                    <i className="flaticon2-calendar-3 kt-font-success" />
                  </div>
                  <div className="kt-notification__item-details">
                    <div className="kt-notification__item-title kt-font-bold">
                      My Profile
                    </div>
                    <div className="kt-notification__item-time">
                      Account settings and more
                    </div>
                  </div>
                </Link>

                <Link to="/my-activity" className="kt-notification__item">
                  <div className="kt-notification__item-icon">
                    <i className="flaticon2-rocket-1 kt-font-danger" />
                  </div>
                  <div className="kt-notification__item-details">
                    <div className="kt-notification__item-title kt-font-bold">
                      My Activities
                    </div>
                    <div className="kt-notification__item-time">
                      Logs and notifications
                    </div>
                  </div>
                </Link>

                <div className="kt-notification__custom kt-space-between">
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      // Clear all localStorage including permissions
                      localStorage.clear();
                      window.location.hash = "/login";
                    }}
                    className="btn btn-label btn-label-brand btn-sm btn-bold"
                  >
                    Sign Out
                  </a>
                </div>
              </div>
              {/*end: Navigation */}
            </div>
          </div>
          {/*end: User Bar */}
        </div>
        {/* end:: Header Topbar */}
      </div>
    );
  }
}
